import { render, staticRenderFns } from "./CheckPatient.vue?vue&type=template&id=3b8da888&"
import script from "./CheckPatient.vue?vue&type=script&lang=js&"
export * from "./CheckPatient.vue?vue&type=script&lang=js&"
import style0 from "./CheckPatient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports